// =============================================
// FORMS — Form submission handlers
// =============================================

(function () {
  function handleForm(formId, successText) {
    var form = document.getElementById(formId);
    if (!form) return;

    form.addEventListener('submit', function (e) {
      e.preventDefault();

      var btn    = form.querySelector('.form-submit');
      var notice = form.querySelector('.form-notice');

      // Prevent double-submit
      if (btn.disabled) return;
      btn.disabled    = true;
      btn.textContent = 'Envoi en cours…';
      if (notice) { notice.textContent = ''; notice.className = 'form-notice'; }

      var data = new FormData(form);

      fetch('send.php', { method: 'POST', body: data })
        .then(function (res) { return res.json(); })
        .then(function (json) {
          if (json.ok) {
            btn.textContent = successText;
            btn.classList.add('sent');
            form.reset();
            if (notice) {
              notice.textContent = successText;
              notice.classList.add('form-notice--ok');
            }
          } else {
            btn.disabled    = false;
            btn.textContent = 'Réessayer';
            if (notice) {
              notice.textContent = json.msg || "Une erreur s'est produite.";
              notice.classList.add('form-notice--err');
            }
          }
        })
        .catch(function () {
          btn.disabled    = false;
          btn.textContent = 'Réessayer';
          if (notice) {
            notice.textContent = "Erreur réseau. Réessayez ou écrivez-nous à contact@compack.io.";
            notice.classList.add('form-notice--err');
          }
        });
    });
  }

  handleForm('form-benevole',    'Candidature envoyée ✓');
  handleForm('form-partenariat', 'Message envoyé ✓');
})();
